import { Controller } from "@hotwired/stimulus"

// Menu szablonu KB "docs" - klik w otwartą kategorię główną zwija i rozwija jej drzewo
// na miejscu, bez przeładowania i bez zapamiętywania stanu. Klik z Cmd/Ctrl/Shift
// (albo środkowym przyciskiem) dalej otwiera stronę kategorii.
export default class extends Controller {
  static targets = ["link", "children"]

  toggle(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return

    event.preventDefault()
    const open = !this.linkTarget.classList.contains("is-open")
    this.linkTarget.classList.toggle("is-open", open)
    this.linkTarget.setAttribute("aria-expanded", String(open))
    this.childrenTarget.classList.toggle("is-collapsed", !open)
  }
}
